module.exports = __webpack_public_path__ + "c0d677afc770b44d80533d209f8e3488.jpg";